var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnarchive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.285,
    height: 15.271,
    viewBox: "0 0 15.285 15.271",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_000000ff",
    "data-name": "#000000ff",
    transform: "translate(15.285 15.271) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74733",
    "data-name": "Group 74733",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M45.55,42.689a2.468,2.468,0,0,1,.59-.04q4.063,0,8.125,0a1.613,1.613,0,0,1,1.293.689q.912,1.217,1.825,2.434a1.008,1.008,0,0,1,.33.968v8.7a3.978,3.978,0,0,1-.048.858,2.054,2.054,0,0,1-.977,1.346,2.107,2.107,0,0,1-1.065.278H44.995a3.631,3.631,0,0,1-1.071-.084,2.052,2.052,0,0,1-1.424-1.5,3.434,3.434,0,0,1-.056-.826q0-4.4,0-8.8a1.222,1.222,0,0,1,.039-.512,1.294,1.294,0,0,1,.291-.421q.889-1.187,1.78-2.374a1.7,1.7,0,0,1,1-.709m.328,1.487c-.38.51-.763,1.017-1.143,1.526H55.422c-.381-.509-.763-1.016-1.143-1.526q-4.2,0-8.4,0M43.97,47.237q0,4.3,0,8.6a.531.531,0,0,0,.277.494,1.037,1.037,0,0,0,.5.063H55.627a.524.524,0,0,0,.384-.141.661.661,0,0,0,.175-.49V47.237Z",
    transform: "translate(-42.435 -42.648)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M174.156,213.472a.854.854,0,0,1,.921-.059.74.74,0,0,1,.345.667q0,1.542,0,3.084c.394-.332.792-.658,1.185-.991a.7.7,0,0,1,.526-.156.776.776,0,0,1,.7.781.736.736,0,0,1-.264.55l-2.028,1.69a1.25,1.25,0,0,1-1.187.324c-.186-.06-.3-.229-.444-.347-.651-.54-1.3-1.084-1.95-1.624a.87.87,0,0,1-.316-.625.778.778,0,0,1,1.178-.628q.541.448,1.078.9c0-.985,0-1.97,0-2.954A.759.759,0,0,1,174.156,213.472Z",
    transform: "translate(-167.016 -207.199)",
    fill: "#111"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchive);
export default __webpack_public_path__ + "static/media/Unarchive.2f205b86639cb0f5e1b233ade5f0b78b.svg";
export { ForwardRef as ReactComponent };